import type { InvoiceProperty } from './Types/InvoiceProperty';

export enum InvoicesActions {
    GET_INVOICES_ENABLED_STATUS = 'GET_INVOICES_ENABLED_STATUS',
    SET_INVOICES_ENABLED_STATUS = 'SET_INVOICES_ENABLED_STATUS',
    LOAD_INVOICE_PROPERTIES = 'INVOICES_LOAD_PROPERTIES',
    SET_INVOICE_PROPERTIES = 'INVOICES_SET_PROPERTIES',
    SET_INVOICE_PROPERTIES_ERROR_STATE = 'INVOICES_SET_PROPERTIES_ERROR_STATE',
}

interface getInvoicesEnabled {
    type: typeof InvoicesActions.GET_INVOICES_ENABLED_STATUS;
}

interface setInvoicesEnabled {
    type: typeof InvoicesActions.SET_INVOICES_ENABLED_STATUS;
    payload: {
        enabled: boolean;
    };
}

interface LoadInvoicePropertiesAction {
    type: typeof InvoicesActions.LOAD_INVOICE_PROPERTIES;
}

interface SetInvoicePropertiesAction {
    type: typeof InvoicesActions.SET_INVOICE_PROPERTIES;
    payload: InvoiceProperty[];
}

interface SetInvoicePropertiesErrorStateAction {
    type: typeof InvoicesActions.SET_INVOICE_PROPERTIES_ERROR_STATE;
    payload: {
        errorMessage: string;
        secondaryMessage?: string;
    };
}

export type InvoicesActionTypes =
    | getInvoicesEnabled
    | setInvoicesEnabled
    | LoadInvoicePropertiesAction
    | SetInvoicePropertiesAction
    | SetInvoicePropertiesErrorStateAction;
